module.exports = __webpack_public_path__ + "img/iconMode.38532516.svg";